export const catalogMenuSections = [
    {
        title: 'Одежда',
        url: '/catalog/odezhda/',
        items: [
            {name: 'Женская', url: '/catalog/tennisnaya_odezhda/?gender=female'},
            {name: 'Мужская', url: '/catalog/tennisnaya_odezhda/?gender=male'},
            {name: 'Детская', url: '/catalog/detskaya_odezhda/'},
        ],
    },
    {
        title: 'Обувь',
        url: '/catalog/tennisnaya_obuv/',
        items: [
            {name: 'Взрослая', url: '/catalog/tennisnaya_obuv/?age=adults'},
            {name: 'Детская', url: '/catalog/tennisnaya_obuv/?age=children'},
        ],
    },
    {
        title: 'Ракетки',
        url: '/catalog/raketki/',
        items: [
            {name: 'Падел', url: '/catalog/raketki_dlya_padela/'},
            {name: 'Теннис', url: '/catalog/tennisnye_raketki/'},
            {name: 'Детские', url: '/catalog/detskie_tennisnye_raketki/'},
        ],
    },
    {
        title: 'Сумки',
        url: '/catalog/sumki/',
        items: [
            {name: 'Для тенниса', url: '/catalog/tennisnye_sumki/'},
            {name: 'Для падела', url: '/catalog/sumki_dlya_padela/'},
        ],
    },
    {
        title: 'Мячи',
        url: '/catalog/myachi/',
        items: [
            {name: 'Для тенниса', url: '/catalog/tennisnye_myachi/'},
            {name: 'Для падела', url: '/catalog/myachi_dlya_padela/'},
        ],
    },
    {
        title: 'Для игры',
        url: '/catalog/dlya_igri/',
        items: [
            {name: 'Струны', url: '/catalog/tennisnye_struni/'},
            {name: 'Намотки', url: '/catalog/namotki/'},
            {name: 'Носки', url: '/catalog/noski/'},
            {name: 'Полотенца', url: '/catalog/polotentsa/'},
            {name: 'Головные уборы', url: '/catalog/golovnie_ubori/'},
            {name: 'Аксессуары', url: '/catalog/aksessuari/'},
            {name: 'Оборудование', url: '/catalog/oborudovanie/'},
        ],
    },
];
